/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_Ask_DiscordInputs */



/**
* | output |
* | --- |
* | "Ask on Discord" |
*
* @param {Layout_Header_Ask_DiscordInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_ask_discord = /** @type {((inputs?: Layout_Header_Ask_DiscordInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_Ask_DiscordInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Auf Discord fragen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Demander sur Discord")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("在 Discord 提问")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("到 Discord 發問")
	if (locale === "ko") return /** @type {LocalizedString} */ ("Discord에서 질문하기")
	return /** @type {LocalizedString} */ ("Ask on Discord")
});